import { lazy } from 'react';

const LegalLeasesApplies = lazy(() =>
  import('components/Legal/Leases/LegalLeasesApplies/index').then(module => ({
    default: module.LegalLeasesApplies,
  }))
);

const LegalLeasesManagements = lazy(() =>
  import('components/Legal/Leases/LegalLeasesManagements/MainScreen/index').then(module => ({
    default: module.LegalLeasesManagements,
  }))
);

const LegalFormLeasesManagements = lazy(() =>
  import('components/Legal/Leases/LegalLeasesManagements/FormScreen/index').then(module => ({
    default: module.LegalFormLeasesManagements,
  }))
);

const LeasesCasesReceived = lazy(() =>
  import('components/Legal/Leases/LegalLeasesCasesReceived/index').then(module => ({
    default: module.LeasesCasesReceived,
  }))
);

const LegalVehiclesApplies = lazy(() =>
  import('components/Legal/Vehicles/VehiclesApplies/VehiclesApplies').then(module => ({
    default: module.LegalVehiclesApplies,
  }))
);

const LegalVehiclesCredits = lazy(() =>
  import('components/Legal/Vehicles/VehiclesCredits/VehiclesCredits').then(module => ({
    default: module.LegalVehiclesCredits,
  }))
);

const LegalFormVehiclesManagement = lazy(() =>
  import('components/Legal/Vehicles/VehiclesManagements/FormManagement/LegalFormVehiclesManagement').then(module => ({
    default: module.LegalFormVehiclesManagement,
  }))
);

const LegalVehiclesManagements = lazy(() =>
  import('components/Legal/Vehicles/VehiclesManagements/MainScreen/LegalVehicleManagements').then(module => ({
    default: module.LegalVehiclesManagements,
  }))
);

const LegalVehiclesSales = lazy(() =>
  import('components/Legal/Vehicles/VehiclesSales/LegalVehiclesSales').then(module => ({
    default: module.LegalVehiclesSales,
  }))
);

const Expenses = lazy(() =>
  import('components/Legal/Expenses/index').then(module => ({
    default: module.Expenses,
  }))
);

const Rates = lazy(() =>
  import('components/Legal/Rates/index').then(module => ({
    default: module.Rates,
  }))
);

const ConsigningAuthorities = lazy(() =>
  import('components/Legal/ConsigningAuthorities/index').then(module => ({
    default: module.ConsigningAuthorities,
  }))
);

const ProcessType = lazy(() =>
  import('components/Legal/ProcessType/index').then(module => ({
    default: module.ProcessType,
  }))
);

const Locations = lazy(() =>
  import('components/Legal/Locations/index').then(module => ({
    default: module.Locations,
  }))
);

const PaymentReception = lazy(() =>
  import('components/Legal/PaymentReception/index').then(module => ({
    default: module.PaymentReception,
  }))
);

const JudicialPremises = lazy(() =>
  import('components/Legal/JudicialPremises/index').then(module => ({
    default: module.JudicialPremises,
  }))
);

const PremisesManagements = lazy(() =>
  import('components/Legal/PremisesManagements/index').then(module => ({
    default: module.PremisesManagements,
  }))
);

const Stamps = lazy(() =>
  import('components/Legal/Stamps/index').then(module => ({
    default: module.Stamps,
  }))
);

const StampsLogs = lazy(() =>
  import('components/Legal/StampsLogs/index').then(module => ({
    default: module.StampsLogs,
  }))
);

const LegalDocuments = lazy(() =>
  import('components/Legal/LegalDocuments/index').then(module => ({
    default: module.LegalDocuments,
  }))
);

const LawyerProcessesFinished = lazy(() =>
  import('components/Legal/LawyerProcessesFinished/index').then(module => ({
    default: module.LawyerProcessesFinished,
  }))
);

const Lawyer = lazy(() =>
  import('components/Legal/Lawyer/index').then(module => ({
    default: module.Lawyer,
  }))
);

const LawyerPayments = lazy(() =>
  import('components/Legal/LawyerPayments/index').then(module => ({
    default: module.LawyerPayments,
  }))
);

const LawyerManagements = lazy(() =>
  import('components/Legal/LawyerManagements/index').then(module => ({
    default: module.LawyerManagements,
  }))
);

const LegalCreditsApplies = lazy(() =>
  import('components/Legal/Credtis/CreditsApplies/LegalCreditsApplies').then(module => ({
    default: module.LegalCreditsApplies,
  }))
);

const LegalCreditsManagements = lazy(() =>
  import('components/Legal/Credtis/CreditsManagments/MainScreen/LegalCreditsManagements').then(module => ({
    default: module.LegalCreditsManagements,
  }))
);

const LegalFormCreditsManagement = lazy(() =>
  import('components/Legal/Credtis/CreditsManagments/FormManagement/LegalFormCreditsManagement').then(module => ({
    default: module.LegalFormCreditsManagement,
  }))
);

const LegalCredits = lazy(() =>
  import('components/Legal/Credtis/Credits/LegalCredits').then(module => ({
    default: module.LegalCredits,
  }))
);

const routesLegal = [

  {
    path: null,
    name: "Arrendamientos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['112_ARRENDAMIENTOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/juridico/arrendamientos/solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <LegalLeasesApplies />,
        permissions: ['115_ARRENDAMIENTOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/arrendamientos/gestiones",
        name: "Otras gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalLeasesManagements />,
        permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-arrendamientos-gestiones-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormLeasesManagements />,
        permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-arrendamientos-gestiones-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormLeasesManagements />,
        permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-arrendamientos-gestiones-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormLeasesManagements />,
        permissions: ['116_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-arrendamientos-casos-recibidos",
        name: "Casos recibidos",
        icon: "nc-icon nc-paper",
        component: <LeasesCasesReceived />,
        permissions: ['117_ARRENDAMIENTOS_CASOS_RECIBIDOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Vehículos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['118_VEHICULOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/legal-vehiculos-ventas",
        name: "Ventas",
        icon: "nc-icon nc-paper",
        component: <LegalVehiclesSales />,
        permissions: ['119_VEHICULOS_VENTAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/legal-vehiculos-creditos",
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: <LegalVehiclesCredits />,
        permissions: ['205_VEHICULOS_CREDITOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-vehiculos-solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <LegalVehiclesApplies />,
        permissions: ['120_VEHICULOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-vehiculos-gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalVehiclesManagements />,
        permissions: ['121_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-gestiones-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormVehiclesManagement />,
        permissions: ['121_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-gestiones-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormVehiclesManagement />,
        permissions: ['121_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-gestiones-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormVehiclesManagement />,
        permissions: ['121_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Creditos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['123_CREDITOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/juridico-creditos",
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: <LegalCredits />,
        permissions: ['237_CREDITOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-creditos-solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <LegalCreditsApplies />,
        permissions: ['124_CREDITOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-creditos-gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalCreditsManagements />,
        permissions: ['125_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico-creditos-gestiones-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormCreditsManagement />,
        permissions: ['125_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-creditos-gestiones-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormCreditsManagement />,
        permissions: ['125_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico-creditos-gestiones-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <LegalFormCreditsManagement />,
        permissions: ['125_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Catalogos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['212_CATALOGOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/juridico/tarifas",
        name: "Tarifas",
        icon: "nc-icon nc-paper",
        component: <Rates />,
        permissions: ['213_TARIFAS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/autoridades",
        name: "Autoridades",
        icon: "nc-icon nc-paper",
        component: <ConsigningAuthorities />,
        permissions: ['214_AUTORIDADES'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/gastos",
        name: "Gastos",
        icon: "nc-icon nc-paper",
        component: <Expenses />,
        permissions: ['215_GASTOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/tipos-de-proceso",
        name: "Tipos de proceso",
        icon: "nc-icon nc-paper",
        component: <ProcessType />,
        permissions: ['216_TIPOS_DE_PROCESO'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/ubicaciones",
        name: "Ubicaciones",
        icon: "nc-icon nc-paper",
        component: <Locations />,
        permissions: ['228_UBICACIONES'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Timbres",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['217_TIMBRES'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/juridico/timbres",
        name: "Timbres",
        icon: "nc-icon nc-paper",
        component: <Stamps />,
        permissions: ['218_TIMBRES'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/timbres-control",
        name: "Control",
        icon: "nc-icon nc-paper",
        component: <StampsLogs />,
        permissions: ['219_CONTROL'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Abogacia & Notariado",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['220_ABOGACIA_&_NOTARIADO'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/juridico/procesos-finalizados",
        name: "Procesos Finalizados",
        icon: "nc-icon nc-paper",
        component: <LawyerProcessesFinished />,
        permissions: ['221_PROCESOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/procesos-activos",
        name: "Procesos Activos",
        icon: "nc-icon nc-paper",
        component: <Lawyer />,
        permissions: ['221_PROCESOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/procesos/pagos/:idlawyer",
        name: "Pagos de procesos",
        icon: "nc-icon nc-paper",
        component: <LawyerPayments />,
        permissions: ['221_PROCESOS'],
        layout: '/app',
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/juridico/documentos",
        name: "Documentos",
        icon: "nc-icon nc-paper",
        component: <LegalDocuments />,
        permissions: ['222_DOCUMENTOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/procesos/gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <LawyerManagements />,
        permissions: ['232_GESTIONES'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
    ],
  },
  {
    path: null,
    name: "Predio Judicial",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['223_PREDIO_JUDICIAL'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/juridico/predio-judicial/recepcion-de-vehiculos",
        name: "Recepción de vehículos",
        icon: "nc-icon nc-paper",
        component: <JudicialPremises />,
        permissions: ['229_RECEPCION_DE_VEHICULOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/juridico/predio-judicial/gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <PremisesManagements />,
        permissions: ['230_GESTIONES'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
      },
    ],
  },
  {
    path: "/juridico/predio-judicial/pagos/:idreception",
    name: "Pagos por predio judicial",
    icon: "nc-icon nc-paper",
    component: <PaymentReception />,
    permissions: ['229_RECEPCION_DE_VEHICULOS'],
    layout: '/app',
    visibility: false,
    subRoutes: [],
  },

];

export {
  routesLegal
}